import React, { useState, useEffect } from "react";
import "./productform.css";
import { toast } from "react-toastify";
import { useParams, useNavigate } from "react-router-dom";

const ProductEditForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [preview, setPreview] = useState(
    "https://cdn-icons-png.flaticon.com/512/10446/10446694.png"
  );
  const [categories, setCategories] = useState([]);
  const [file, setFile] = useState(null);

  const [formData, setFormData] = useState({
    product_title: "",
    category_id: "",
    description: "",
  });

  useEffect(() => {
    if (id) {
      fetchCategories();
      fetchProductById();
    } else {
      toast.error("No product ID provided for edit.");
      navigate("/products");
    }
  }, [id]);

  const fetchCategories = async () => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await fetch("https://backend.soapplants.com/api/v1/category/view", {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });
      const result = await response.json();
      if (response.status === 401) {
        toast.error("Session expired, please log in again");
        localStorage.removeItem("authToken");
        navigate('/login');
        return;
      }
      if (result.success) setCategories(result.data);
      else toast.error(result.message);
    } catch (err) {
      console.error(err);
      toast.error("Failed to fetch categories");
    }
  };

  const fetchProductById = async () => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await fetch(
        `https://backend.soapplants.com/api/v1/product/viewproductbyid`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ id }),
        }
      );
        if (response.status === 401) {
          toast.error("Session expired, please log in again");
          localStorage.removeItem("authToken");
          navigate('/login');
          return;
        }
      const result = await response.json();
      if (result.success && result.data) {
        setFormData({
          product_title: result.data.product_title || "",
          category_id: result.data.category_id || "",
          description: result.data.description || "",
        });
        if (result.data.image_url) setPreview(result.data.image_url);
      } else {
        toast.error(result.message || "Product not found");
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to fetch product details");
    }
  };

  const loadFile = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setPreview(URL.createObjectURL(selectedFile));
      setFile(selectedFile);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleUpdate = async (e) => {
    e.preventDefault();

    const data = new FormData();
    data.append("id", id);
    data.append("product_title", formData.product_title);
    data.append("category_id", formData.category_id);
    data.append("description", formData.description);
    if (file) data.append("image", file);

    try {
      const token = localStorage.getItem("authToken");
      const response = await fetch("https://backend.soapplants.com/api/v1/product/edit", {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: data,
      });

      const result = await response.json();
      if (response.status === 401) {
        toast.error("Session expired, please log in again");
        localStorage.removeItem("authToken");
       navigate('/login');
        return;
      }
      if (result.success) {
        toast.success("Product updated successfully!");
        navigate(`/product-details`);
      } else {
        toast.error(result.message || "Failed to update product");
      }
    } catch (err) {
      console.error(err);
      toast.error("Error updating product");
    }
  };
  const handleDescriptionChange = (e) => {
  const value = e.target.value;
  const words = value.trim().split(/\s+/).filter(w => w.length > 0);

  if (words.length > 60) {
    return; 
  }

  setFormData({
    ...formData,
    description: value
  });
};
  return (
    <div className="product-form">
      <h2>Edit Product</h2>
      <form className="form-section" onSubmit={handleUpdate}>
        <div className="card left-section">
          <div className="image-section">
            <label htmlFor="fileSelect">
              <img src={preview} alt="Preview" className="image-preview" />
            </label>
            <input
              type="file"
              id="fileSelect"
              className="hidden"
              accept="image/*"
              onChange={loadFile}
            />
          </div>

          <div className="input-section">
            <div className="form-group">
              <label className="form-label">Product Title</label>
              <input
                type="text"
                name="product_title"
                className="form-input"
                value={formData.product_title}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label">Select Category</label>
              <select
                name="category_id"
                className="form-input"
                value={formData.category_id}
                onChange={handleChange}
                required
              >
                <option value="">-- Select Category --</option>
                {categories.map((category) => (
                  <option key={category.id} value={category.id}>
                    {category.category_name}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label className="form-label">Description (Minimum & Maximum 60 words)</label>

              <textarea
                name="description"
                className="form-input textarea"
                value={formData.description}
                onChange={handleDescriptionChange}
                required
              ></textarea>

              
              <p style={{ fontSize: "12px", marginTop: "5px" }}>
                Words: {formData.description.trim() === "" 
                  ? 0 
                  : formData.description.trim().split(/\s+/).length} / 60
              </p> 
            </div>

            <div className="button-row">
              <button type="submit" className="product-save-button">
                Update
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default ProductEditForm;
